import { PressableNeolexon } from '@/components/PressableNeolexon';
import colors from '@/config/colors';
import { ReactElement, cloneElement } from 'react';
import { StyleSheet } from 'react-native';
import { Text } from '@/components/Text';

interface AppHeaderActionProps {
  primary?: boolean;
  disabled?: boolean;
  icon?: ReactElement;
  text?: string;
  onPress: () => void;
  testID?: string;
}

export function AppHeaderAction({
  primary = false,
  icon,
  text,
  onPress,
  disabled,
  testID,
}: AppHeaderActionProps) {
  return (
    <PressableNeolexon
      disabled={disabled}
      style={[styles.base, disabled && styles.dim]}
      onPress={onPress}
      testID={testID}
    >
      {!!icon &&
        cloneElement(icon, {
          size: 22 * (icon?.props?.scale || 1),
          color: primary ? colors.white : colors.black,
        })}
      {!!text && (
        <Text
          style={{
            fontSize: 17,
            color: primary ? colors.white : colors.black,
          }}
        >
          {text}
        </Text>
      )}
    </PressableNeolexon>
  );
}

const styles = StyleSheet.create({
  base: { flexDirection: 'row', gap: 4, alignItems: 'center' },
  dim: { opacity: 0.4 },
});
